import React from 'react';
import { Github, Twitter, Linkedin } from 'lucide-react';

export default function Footer() {
	return (
		<footer className="bg-white border-t border-gray-200 mt-8">
			<div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
				<p className="text-sm text-gray-500">© {new Date().getFullYear()} Resumly. All rights reserved.</p>
				<div className="flex items-center gap-4 text-sm">
					<a href="#about" className="text-gray-600 hover:text-primary-600">
						About
					</a>
					<a href="#privacy" className="text-gray-600 hover:text-primary-600">
						Privacy
					</a>
					<a href="#terms" className="text-gray-600 hover:text-primary-600">
						Terms
					</a>
					<a href="#contact" className="text-gray-600 hover:text-primary-600">
						Contact
					</a>
				</div>
				<div className="flex items-center gap-3">
					<a href="https://github.com" className="text-gray-600 hover:text-primary-600" aria-label="Github" target="_blank" rel="noopener noreferrer">
						<Github className="w-5 h-5" />
					</a>
					<a href="https://twitter.com" className="text-gray-600 hover:text-primary-600" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
						<Twitter className="w-5 h-5" />
					</a>
					<a href="https://linkedin.com" className="text-gray-600 hover:text-primary-600" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
						<Linkedin className="w-5 h-5" />
					</a>
				</div>
			</div>
		</footer>
	);
}


